import React from 'react';
import PropTypes from 'prop-types';
import locale from '@glu/locale';
import { withStyles } from '@glu/theming';

import styles from './OptionalInlineText.styles';

const propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  /** Boolean to indicate whether the label is being used with a textarea */
  withTextarea: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  /** Shows LabelText in red if true (used in styles) */
  hasError: PropTypes.bool // eslint-disable-line react/no-unused-prop-types
};

const defaultProps = {
  withTextarea: false,
  hasError: false
};

const OptionalInlineText = ({ classes }) => (
  <span className={classes.root} data-qa="optional-inline-span">{locale.get('optional')}</span>
);

OptionalInlineText.propTypes = propTypes;
OptionalInlineText.defaultProps = defaultProps;

export default withStyles(styles)(OptionalInlineText);
